import { inject, Injectable } from '@angular/core';
import { FiltersSearchFacade } from 'src/app/search/state/filters-search/filters-search.facade';

@Injectable({
  providedIn: 'root',
})
export class FiltersSearchResetResolver {
  private readonly filtersSearchFacade = inject(FiltersSearchFacade);

  resolve() {
    return this.filtersSearchFacade.resetStore();
  }
}
